import React, { useContext } from 'react'
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow
} from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { DailyMonitoringDetailsFiltersContext } from '../../../../../context/DailyMonitoringDetailsFiltersContext'
import DefaultTableCell from '../../../../../components/DefaultTableCell'
import DailyOrderTotals from './DailyOrderTotals'
import DailyOrderQuantity from './DailyOrderQuantity'
import DailyOrderOpenGMV from './DailyOrderOpenGMV'
import DailyOrdersPharmaciesQuantity from './DailyOrdersPharmaciesQuantity'
import DailyOrderTotalsAverage from './DailyOrderTotalsAverage'
import DailyPharmaciesQuantity from './DailyPharmaciesQuantity'
import DailyCostumersQuantity from './DailyCostumersQuantity'
import DailyActivation from './DailyActivation'
// import DailyCredentialsQuantity from './DailyCredentialsQuantity'
import { getDaysInMonth, DaysInMonth } from '../../../../../utils/Helpers'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2)
    }
  })
)

export default function DailyTotals (): JSX.Element {
  const classes = useStyles()
  const { filters } = useContext(DailyMonitoringDetailsFiltersContext)

  return (
    <Card className={classes.root}>
      <CardContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <DefaultTableCell
                  style={{ maxWidth: 200, backgroundColor: '#2D4054' }}
                ></DefaultTableCell>
                {getDaysInMonth(filters.date.year, filters.date.month).map(
                  (day: DaysInMonth) => {
                    return (
                      <DefaultTableCell
                        key={day.date}
                        style={{
                          textAlign: 'center',
                          backgroundColor: '#2D4054'
                        }}
                        className={day.isWeekend ? 'weekend' : ''}
                      >
                        {day.date}
                      </DefaultTableCell>
                    )
                  }
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              <DailyOrderTotals />
              <DailyOrderQuantity />
              <DailyOrderOpenGMV />
              <DailyOrdersPharmaciesQuantity />
              <DailyOrderTotalsAverage />
              {/* <DailyCredentialsQuantity /> */}
              <DailyActivation />
              <DailyPharmaciesQuantity />
              <DailyCostumersQuantity />
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  )
}
